import { Box, CircularProgress, Container, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import { Image } from '@mui/icons-material';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class Circulares extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            loading: false,
            circular: {
                titulo: '',
                archivo: '',
            },

            imagenMostrarModal: false,
            mostrarCircular: false,
            modalBorrar: false,
            modalFinalizar: false,

            datoEspecifico: {},

            datosConsulta: [],
        }

        this.manejoEnvioConsultaCircular = this.manejoEnvioConsultaCircular.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioCircular = this.manejarEnvioCircular.bind(this);
        this.manejarConsultaImagen = this.manejarConsultaImagen.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarMostrarCircular = this.manejarMostrarCircular.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
        this.manejarBorrarCircular = this.manejarBorrarCircular.bind(this);
        this.manejarFinalizarCircular = this.manejarFinalizarCircular.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.consultaRealizada || this.state.mostrarCircular
                    ?
                        null
                    :
                        <form className='formulario1'  onSubmit={this.manejoEnvioConsultaCircular}>
                            <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={5}>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-success mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    }
                    {this.state.consultaRealizada || this.state.mostrarCircular
                    ?
                        null
                    :
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={2}>
                                    Título
                                </Grid>
                                <Grid item xs={2}>
                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='titulo' value={this.state.circular.titulo} onChange={this.manejarCambiosDatos}/>
                                </Grid>
                                <Grid item xs={2}>
                                    Archivo Base
                                </Grid>
                                <Grid item xs={2}>
                                    <input type='file' id='archivo' style={{content: 'Seleccionar'}} onChange={this.manejarCambiosDatos}></input>
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                            </Grid>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCircular}>Enviar</button>
                        </Box>
                    }
                    {this.state.consultaRealizada
                    ?
                        <Container>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Título</StyledTableCell>
                                        <StyledTableCell>Archivo Base</StyledTableCell>
                                        <StyledTableCell>Mostrar Circular</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.datosConsulta.map((name) => (
                                        <StyledTableRow key={name.idCirculares}>
                                            <StyledTableCell>{name.titulo}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaImagen(name.archivoBase)}>Consultar</button></StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarMostrarCircular(name)}>Ver</button></StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarBorrarCircular(name)}>Borrar</button></StyledTableCell>
                                            {name.activa === 1 ? <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarFinalizarCircular(name)}>Finalizar</button></StyledTableCell> : <StyledTableCell></StyledTableCell>}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }

                    {this.state.imagenMostrarModal
                    ?
                        <Modal open={this.state.imagenMostrarModal}>
                            <Box sx={styleModal} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <img src={this.state.imagenMostrar} alt="" style={{ width: '90%'}}/>
                                    <Grid item xs={5}>
                                        
                                    </Grid>
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Modal>
                    :
                        null
                    }
                    {this.state.mostrarCircular
                    ?
                        <Container>
                            <h3>{this.state.datoEspecifico.titulo}</h3>
                            <img style={{marginTop: 50, width:'100%'}} src={this.state.datoEspecifico.archivoBase}/>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarVolver}>Volver</button>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    async manejoEnvioConsultaCircular(e){
        e.preventDefault();
        this.setState({
            loading: true,
        });
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_circulares.php`);
        const res = await numNom.json();
        this.setState({
            errores: res[0],
            loading: false,
        });
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                datosConsulta: res[1],
                consultaRealizada: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            loading: false,
            notificaciones: null,
        })
        const clave = e.target.id;
        if(clave === 'archivo'){
            let valor = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (e) => {
                e.preventDefault();
                this.setState(state => {
                    const numFunActualizado = state.circular;
                    numFunActualizado[clave] = e.target.result;
                    
                    return{
                        circular: numFunActualizado,
                    };
                });
            };
        }else{
            let valor = e.target.value;
            this.setState({
                errores: null,
                notificaciones: null,
            });
            this.setState(state => {
                const numFunActualizado = state.circular;
                numFunActualizado[clave] = valor;
                
                return{
                    circular: numFunActualizado,
                };
            });
        }
    }

    async manejarEnvioCircular(e){
        e.preventDefault();
        if(this.state.circular.titulo === ''){
            this.setState({
                errores: 'Debe indicar el titulo de la circular',
            })
        }else if((this.state.circular.archivo === '')){
            this.setState({
                errores: 'Debe ingresar el archivo base',
            })
        }else{
            this.setState({
                loading: true,
            })

            const cargaUtil = JSON.stringify([this.state.circular]);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/agregar_circular.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
                loading: false,
            });
            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    circular: {
                        titulo: '',
                        archivo: '',
                    }
                })
            }
        }
    }

    manejarConsultaImagen(dato){
        this.setState({
            imagenMostrarModal: true,
            imagenMostrar: dato,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            imagenMostrarModal: false,
            imagenMostrar: {},
        })
    }

    manejarMostrarCircular(dato){
        this.setState({
            consultaRealizada: false,
            mostrarCircular: true,
            datoEspecifico: dato,
        })
    }

    manejarVolver(e){
        e.preventDefault();
        this.setState({
            mostrarCircular: false,
            datoEspecifico: {},
            consultaRealizada: true,
        })
    }

    manejarBorrarCircular(dato){
        this.setState({
            datoEspecifico: dato,
            modalBorrar: true,
        })
    }

    manejarFinalizarCircular(dato){
        this.setState({
            datoEspecifico: dato,
            modalFinalizar: true,
        })
    }
}

export default Circulares